module.exports = __webpack_public_path__ + "static/media/social-life-icon.c84ec213.svg";